
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ContentPreview from './components/ContentPreview';
import CommercePreview from './components/CommercePreview';
import CommunitySection from './components/CommunitySection';
import CTASection from './components/CTASection';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <CommunitySection />
      <ContentPreview />
      <CommercePreview />
      <CTASection />
      <Footer />
    </div>
  );
}
